import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableTermsAndConditions = Loadable({
  loader: function loader() {
    return import('../TermsAndConditions.jsx');
  },
  loading: ComponentLoading
});
export default LoadableTermsAndConditions;